import { VideoOption } from '@openx/types/targeting/video';
import { extendOptionNameWithParentName } from '@openx/utils/lib/extendOptionNameWithParentName';
import { useMemo } from 'react';

import { useVideoFormatOptionsFetch } from './useVideoFormatOptionsFetch';
import { useVideoLocationOptionsFetch } from './useVideoLocationOptionsFetch';
import { useVideoPlacementOptionsFetch } from './useVideoPlacementOptionsFetch';

export const useVideoOptionsFetch = (type: VideoOption, isUsed = true) => {
  const format = useVideoFormatOptionsFetch({ enabled: isUsed && type === VideoOption.PRESENTATION_FORMAT });
  const location = useVideoLocationOptionsFetch({ enabled: isUsed && type === VideoOption.IN_STREAM_VIDEO_POSITION });
  const placement = useVideoPlacementOptionsFetch({ enabled: isUsed && type === VideoOption.PLACEMENT });

  return useMemo(
    () =>
      ({
        [VideoOption.PRESENTATION_FORMAT]: {
          isLoading: format.loading,
          options: format.mapById,
        },
        [VideoOption.IN_STREAM_VIDEO_POSITION]: {
          isLoading: location.loading,
          options: extendOptionNameWithParentName(location.mapById),
        },
        [VideoOption.PLACEMENT]: {
          isLoading: placement.loading,
          options: placement.mapById,
        },
      })[type] || { isLoading: false, options: {} },
    [format.mapById, format.loading, location.mapById, location.loading, placement.mapById, placement.loading, type]
  );
};
